import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate('/painel', { replace: true });
  }, [user, navigate]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate('/painel', { replace: true });
    } catch (err) {
      const msg = (err as { message?: string })?.message ?? 'Login falhou';
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen grid place-items-center bg-[var(--bg-subtle)] px-4">
      <div className="w-full max-w-sm">
        <p className="text-center text-xs font-semibold tracking-widest text-[var(--text-dim)] uppercase">
          Parceiro autorizado Claro Empresas
        </p>
        <h1 className="mt-2 text-center text-2xl font-semibold tracking-tight">Entrar no painel</h1>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label htmlFor="email" className="mb-1 block text-sm font-medium">Email</label>
            <input
              id="email" type="email" required autoComplete="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 rounded-lg border border-[var(--border-strong)] bg-white px-3 text-sm focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)]"
            />
          </div>
          <div>
            <label htmlFor="password" className="mb-1 block text-sm font-medium">Senha</label>
            <input
              id="password" type="password" required autoComplete="current-password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-11 rounded-lg border border-[var(--border-strong)] bg-white px-3 text-sm focus:outline-none"
            />
          </div>
          <button
            type="submit" disabled={busy}
            className="w-full h-11 rounded-lg bg-[var(--accent)] text-sm font-semibold text-white transition-colors hover:bg-[#c40a20] disabled:opacity-50"
          >
            {busy ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-[var(--text-dim)]">
          Acesso com credenciais do seu time
        </p>
      </div>
    </main>
  );
}
